<template>
  <div class="m-2">
    <span
      class="rounded-full px-3 py-1 ml-auto mr-auto cursor-pointer text-sm text-white font-normal whitespace-no-wrap"
      :class="conditionalClasses"
      @click="$emit('click', $event)"
    >
      <slot>
        {{ text }}
      </slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ZButton',
  props: {
    type: { type: String, default: 'primary' },
    text: { type: String, default: 'OK' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    conditionalClasses () {
      return {
        'bg-blue-400': this.type === 'primary' && !this.disabled,
        'bg-white text-blue-400 border-blue-400 border': this.type === 'secondary' && !this.disabled,
        'bg-red-400': this.type === 'destructive' && !this.disabled,
        'cursor-not-allowed bg-gray-300 text-gray-600': this.disabled
      }
    }
  }
}
</script>
